var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexy1"},[_c('div',{staticClass:"container has-text-centered"},[_c('h2',{staticClass:"is-size-3 is-loading"},[_c('b-loading',{attrs:{"active":true}}),_vm._v(" .... autentificare in curs .... ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }